import { Breadcrumbs } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { IoCheckmarkCircleOutline } from 'react-icons/io5'
import { useSelector } from 'react-redux'
import { NavLink, useNavigate } from 'react-router-dom'
import { url } from '../configlink'

function SurveyWps() {

    let [surveyData, setSurveyData] = useState({
        dQualityRating: '',
        dQualityComments: '',
        oxNanoRating: '',
        oxNanoComments: '',
        reportRating: '',
        reportComments: '',
        tatRating: '',
        tatComments: '',
        pricingRating:'',
        pricingComments:'',
        orderingRating: '',
        orderingComments: '',
        dropboxRating: '',
        dropboxComments: '',
        servicesRating: '',
        servicesComments: '',
        sangerRating: '',
        sangerComments: '',
        miscComments: '',
        contactTheCustomer: 'Yes'
    })

    const user = useSelector((state) => state.user.user)

    let [surveyAnswered, setSurveyAnswered] = useState(false)
    let [buttonColor, setButtonColor] = useState(false)
    let [surveyView, setSurveyView] = useState(true)
    
    const navigate = useNavigate();

    useEffect(() => {
        fetch(`${url}/api/users/checkWPSsurveyValidity?userId=${user.UserId}`,{
            method:"GET",
            credentials: "include",
            // headers: {
            //   Authorization: `Bearer ${token}`,
            // }
        })
        .then(res => res.json())
        .then(data => {
            // console.log("HI",data);
            setSurveyView(data)
            
            window.scrollTo(0,100)
        })

    },[])

    const [errors, setErrors] = useState({});

    const validateSurvey = () => {
        const newErrors = {};

        if (!surveyData.dQualityComments) newErrors.dQualityComments = 'Please Enter'
        
        if (!surveyData.oxNanoComments) newErrors.oxNanoComments = 'Please Enter'
        
        if (!surveyData.reportComments) newErrors.reportComments = 'Please Enter'
        
        if (!surveyData.tatComments) newErrors.tatComments = 'Please Enter'

        if (!surveyData.pricingComments) newErrors.pricingComments = 'Please Enter'
        
        if (!surveyData.orderingComments) newErrors.orderingComments = 'Please Enter'

        if (!surveyData.dropboxComments) newErrors.dropboxComments = 'Please Enter'

        if (!surveyData.servicesComments) newErrors.servicesComments = 'Please Enter'

        if (!surveyData.sangerComments) newErrors.sangerComments = 'Please Enter'

        if (!surveyData.miscComments) newErrors.miscComments = 'Please Enter'

        return newErrors
    };
    
    function handleSurvey(){

    const validationErrors = validateSurvey();
    // console.log("here", validationErrors);

    if (Object.keys(validationErrors).length > 0) {
        setErrors(validationErrors)
    }
    else {
        // console.log('PASS');
        
        let data2 = {
            ...surveyData, 
            name: `${user.FirstName} ${user.LastName}`,
            email: user.EmailAddress,
            company: user.company,
            userId: user.UserId
        }
        
        // console.log(data2);
        setButtonColor(true)

        try {
            fetch(`${url}/api/orderForm/surveyWPS`, {
              method: "POST",
              credentials: 'include',
              headers: {
                // Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
              body: JSON.stringify(data2),
            })
            .then(res => res.json())
            .then(data => {
              if(data.message === 'success'){
                setSurveyAnswered(true)
              }
              setButtonColor(false)
            })
          } catch (error) {
            setButtonColor(false)
            console.log(error);
            
          } 
    }      
    }
    

  return (
    <> {
        surveyView ? 
        <div className=' px-[16px] sm:px-[40px] xl:px-[128px]'>
        <div className="flex flex-col sm:flex-row justify-between items-center my-[40px] gap-[20px]">
          <h1 className='text-center sm:!text-left text-4xl text-[var(--color-primary-purple)] font-black '>
           Survey: Whole Plasmid Sequencing
          </h1>
        </div>
        
        {surveyAnswered ? 
            <div className="flex flex-col items-center gap-[10px] mt-10">
                <div className="flex items-center justify-center gap-[8px]">
                    {/* <IoCheckmarkCircleOutline className='h-[36px] w-[36px] text-[#60C5C5]' /> */}
                    {/* <p className="text-center font-bold text-2xl text-[var(--color-primary-purple)]">Thank you for your response!</p> */}
                    <div className="flex flex-col gap-[20px] w-[80%] mt-8">
                        <p className="text-center font-bold text-2xl text-[var(--color-primary-purple)]">Thank you for completing our survey.</p>
                        <p className='text-center font-bold text-lg'>Please check your inbox for a discount code which can be applied towards Whole Plasmid Sequencing service. Enter this code in the Discount Code field of the Billing and Shipping checkout page. Should you have any questions please reach out to us at <a className='text-blue-800 underline' href="mailto:wps@acgtinc.com">wps@acgtinc.com</a>.</p>
                    </div>
                </div>
                <button
                className='mt-12 border-2 border-[#302a7e] px-4 py-2 rounded-3xl font-bold gap-2 text-[var(--color-primary-purple)] bg-white uppercase min-w-[289px] h-[43px] mb-16'
                onClick={() => navigate('/dashboard')}
                >
                    go back to account home
                </button>
            </div>
            :
            <div>
                <p className='text-2xl font-bold'>We want to hear from you!</p>
                <p className='text-lg mt-2'>Thank you for your recent Whole Plasmid Sequencing (WPS) order. ACGT is working hard to improve our service, and your feedback is invaluable. We appreciate your time with the following survey and as always, feel free to reach out to us with any questions.</p>
            
                <div className='mt-5 flex flex-col gap-[80px] sm:px-16'>
                    <div className='flex flex-col gap-[10px]'>
                        <p className='text-xl font-black'>Data Quality</p>
                        <p className='text-lg'>The WPS data quality is accurate compared to other sequencing providers.</p>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="dQuality-radio" value={"Strongly Disagree"} onChange={(e) => setSurveyData({...surveyData, dQualityRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Strongly Disagree</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="dQuality-radio" value={"Slightly Disagree"} onChange={(e) => setSurveyData({...surveyData, dQualityRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Slightly Disagree</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="dQuality-radio" value={"Neutral"} onChange={(e) => setSurveyData({...surveyData, dQualityRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Neutral</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="dQuality-radio" value={"Slightly Agree"} onChange={(e) => setSurveyData({...surveyData, dQualityRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Slightly Agree</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="dQuality-radio" value={"Strongly Agree"} onChange={(e) => setSurveyData({...surveyData, dQualityRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Strongly Agree</p>
                        </div>
                        <p className='mt-2 text-lg'>Comments:<span className='text-red-600 text-2xl'>*</span></p>
                        <textarea value={surveyData.dQualityComments} 
                        onChange={(e) => {
                            setErrors({...errors, dQualityComments: ''})
                            setSurveyData({...surveyData, dQualityComments:e.target.value}) 
                        }} 
                        rows={4} className='p-2 border border-black w-full xl:w-[800px]' />
                        {errors.dQualityComments && (
                            <span className='text-[14px] text-red-500 font-bold'>{errors.dQualityComments}</span>
                        )}
                    </div>
                    <div className='flex flex-col gap-[10px]'>
                        {/* <p className='text-xl font-black'>Ordering & Checkout</p> */}
                        <p className='text-lg'>Sequencing by Oxford Nanopore Technologies (ONT) is superior to traditional Sanger sequencing.</p>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="oxNano-radio" value={"Strongly Disagree"} onChange={(e) => setSurveyData({...surveyData, oxNanoRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Strongly Disagree</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="oxNano-radio" value={"Slightly Disagree"} onChange={(e) => setSurveyData({...surveyData, oxNanoRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Slightly Disagree</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="oxNano-radio" value={"Neutral"} onChange={(e) => setSurveyData({...surveyData, oxNanoRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Neutral</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="oxNano-radio" value={"Slightly Agree"} onChange={(e) => setSurveyData({...surveyData, oxNanoRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Slightly Agree</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="oxNano-radio" value={"Strongly Agree"} onChange={(e) => setSurveyData({...surveyData, oxNanoRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Strongly Agree</p>
                        </div>
                        <p className='mt-2 text-lg'>Comments:<span className='text-red-600 text-2xl'>*</span></p>
                        <textarea value={surveyData.oxNanoComments} 
                        onChange={(e) => {
                            setErrors({...errors, oxNanoComments: ''})
                            setSurveyData({...surveyData, oxNanoComments:e.target.value})
                        }} 
                        rows={4} className='p-2 border border-black  w-full xl:w-[800px]' />
                        {errors.oxNanoComments && (
                            <span className='text-[14px] text-red-500 font-bold'>{errors.oxNanoComments}</span>
                        )}
                    </div>
                    <div className='flex flex-col gap-[10px]'>
                        <p className='text-xl font-black'>Deliverables</p>
                        <p className='text-lg'>The report(s) and data I received is comprehensive and sufficient for my needs.</p>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="report-radio" value={"Strongly Disagree"} onChange={(e) => setSurveyData({...surveyData, reportRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Strongly Disagree</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="report-radio" value={"Slightly Disagree"} onChange={(e) => setSurveyData({...surveyData, reportRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Slightly Disagree</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="report-radio" value={"Neutral"} onChange={(e) => setSurveyData({...surveyData, reportRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Neutral</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="report-radio" value={"Slightly Agree"} onChange={(e) => setSurveyData({...surveyData, reportRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Slightly Agree</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="report-radio" value={"Strongly Agree"} onChange={(e) => setSurveyData({...surveyData, reportRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Strongly Agree</p>
                        </div>
                        <p className='mt-2 text-lg'>Comments:<span className='text-red-600 text-2xl'>*</span></p>
                        <textarea value={surveyData.reportComments} onChange={(e) => {
                            setErrors({...errors, reportComments:''})
                            setSurveyData({...surveyData, reportComments:e.target.value}) 
                        }} 
                        rows={4} className='p-2 border border-black  w-full xl:w-[800px]' />
                        {errors.reportComments && (
                            <span className='text-[14px] text-red-500 font-bold'>{errors.reportComments}</span>
                        )}
                    </div>
                    <div className='flex flex-col gap-[10px]'>
                        <p className='text-xl font-black'>Turnaround Time</p>
                        <p className='text-lg'>The WPS turnaround time is satisfactory and sufficient for my needs.</p>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="tat-radio" value={"Strongly Disagree"} onChange={(e) => setSurveyData({...surveyData, tatRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Strongly Disagree</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="tat-radio" value={"Slightly Disagree"} onChange={(e) => setSurveyData({...surveyData, tatRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Slightly Disagree</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="tat-radio" value={"Neutral"} onChange={(e) => setSurveyData({...surveyData, tatRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Neutral</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="tat-radio" value={"Slightly Agree"} onChange={(e) => setSurveyData({...surveyData, tatRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Slightly Agree</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="tat-radio" value={"Strongly Agree"} onChange={(e) => setSurveyData({...surveyData, tatRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Strongly Agree</p>
                        </div>
                        <p className='mt-2 text-lg'>Comments:<span className='text-red-600 text-2xl'>*</span></p>
                        <textarea value={surveyData.tatComments} onChange={(e) => {
                            setErrors({...errors, tatComments: ''})
                            setSurveyData({...surveyData, tatComments:e.target.value}) 
                        }} 
                        rows={4} className='p-2 border border-black  w-full xl:w-[800px]' />
                        {errors.tatComments && (
                            <span className='text-[14px] text-red-500 font-bold'>{errors.tatComments}</span>
                        )}
                    </div>
                    <div className='flex flex-col gap-[10px]'>
                        <p className='text-xl font-black'>Price</p>
                        <p className='text-lg'>WPS is reasonably and competitively priced.</p>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="pricing-radio" value={"Strongly Disagree"} onChange={(e) => setSurveyData({...surveyData, pricingRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Strongly Disagree</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="pricing-radio" value={"Slightly Disagree"} onChange={(e) => setSurveyData({...surveyData, pricingRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Slightly Disagree</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="pricing-radio" value={"Neutral"} onChange={(e) => setSurveyData({...surveyData, pricingRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Neutral</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="pricing-radio" value={"Slightly Agree"} onChange={(e) => setSurveyData({...surveyData, pricingRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Slightly Agree</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="pricing-radio" value={"Strongly Agree"} onChange={(e) => setSurveyData({...surveyData, pricingRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Strongly Agree</p>
                        </div>
                        <p className='mt-2 text-lg'>Comments:<span className='text-red-600 text-2xl'>*</span></p>
                        <textarea value={surveyData.pricingComments} onChange={(e) => {
                            setErrors({...errors, pricingComments: ''})
                            setSurveyData({...surveyData, pricingComments:e.target.value})
                        }} 
                        rows={4} className='p-2 border border-black  w-full xl:w-[800px]' />
                        {errors.pricingComments && (
                            <span className='text-[14px] text-red-500 font-bold'>{errors.pricingComments}</span>
                        )}
                    </div>
                    <div className='flex flex-col gap-[10px]'>
                        <p className='text-xl font-black'>Ordering & Checkout</p>
                        <p className='text-lg'>Ordering through ACGT&apos;s website is easy and intuitive.</p>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="order-radio" value={"Strongly Disagree"} onChange={(e) => setSurveyData({...surveyData, orderingRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Strongly Disagree</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="order-radio" value={"Slightly Disagree"} onChange={(e) => setSurveyData({...surveyData, orderingRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Slightly Disagree</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="order-radio" value={"Neutral"} onChange={(e) => setSurveyData({...surveyData, orderingRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Neutral</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="order-radio" value={"Slightly Agree"} onChange={(e) => setSurveyData({...surveyData, orderingRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Slightly Agree</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="order-radio" value={"Strongly Agree"} onChange={(e) => setSurveyData({...surveyData, orderingRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Strongly Agree</p>
                        </div>
                        <p className='mt-2 text-lg'>Comments:<span className='text-red-600 text-2xl'>*</span></p>
                        <textarea value={surveyData.orderingComments} onChange={(e) => {
                            setErrors({...errors, orderingComments: ''})
                            setSurveyData({...surveyData, orderingComments:e.target.value}) 
                        }} 
                        rows={4} className='p-2 border border-black  w-full xl:w-[800px]' />
                        {errors.orderingComments && (
                            <span className='text-[14px] text-red-500 font-bold'>{errors.orderingComments}</span>
                        )}
                    </div>
                    <div className='flex flex-col gap-[10px]'>
                        <p className='text-xl font-black'>Dropboxes & Shipping</p>
                        <p className='text-lg'>Shipping my samples to ACGT is easy and convenient. Dropboxes are appropriately located at our campus.</p>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="dropbox-radio" value={"Strongly Disagree"} onChange={(e) => setSurveyData({...surveyData, dropboxRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Strongly Disagree</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="dropbox-radio" value={"Slightly Disagree"} onChange={(e) => setSurveyData({...surveyData, dropboxRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Slightly Disagree</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="dropbox-radio" value={"Neutral"} onChange={(e) => setSurveyData({...surveyData, dropboxRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Neutral</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="dropbox-radio" value={"Slightly Agree"} onChange={(e) => setSurveyData({...surveyData, dropboxRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Slightly Agree</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="dropbox-radio" value={"Strongly Agree"} onChange={(e) => setSurveyData({...surveyData, dropboxRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Strongly Agree</p>
                        </div>
                        <p className='mt-2 text-lg'>Comments:<span className='text-red-600 text-2xl'>*</span></p>
                        <textarea value={surveyData.dropboxComments} onChange={(e) => {
                            setErrors({...errors, dropboxComments:''})
                            setSurveyData({...surveyData, dropboxComments:e.target.value}) 
                        }} 
                        rows={4} className='p-2 border border-black  w-full xl:w-[800px]' />
                        {errors.dropboxComments && (
                            <span className='text-[14px] text-red-500 font-bold'>{errors.dropboxComments}</span>
                        )}
                    </div>
                    <div className='flex flex-col gap-[10px]'>
                        <p className='text-xl font-black'>Customer Service</p>
                        <p className='text-lg'>Customer service is accessible, timely and responsive. The ACGT representative demonstrates knowledge and competence in resolving issues.</p>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="services-radio" value={"Strongly Disagree"} onChange={(e) => setSurveyData({...surveyData, servicesRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Strongly Disagree</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="services-radio" value={"Slightly Disagree"} onChange={(e) => setSurveyData({...surveyData, servicesRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Slightly Disagree</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="services-radio" value={"Neutral"} onChange={(e) => setSurveyData({...surveyData, servicesRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Neutral</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="services-radio" value={"Slightly Agree"} onChange={(e) => setSurveyData({...surveyData, servicesRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Slightly Agree</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="services-radio" value={"Strongly Agree"} onChange={(e) => setSurveyData({...surveyData, servicesRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Strongly Agree</p>
                        </div>
                        <p className='mt-2 text-lg'>Comments:<span className='text-red-600 text-2xl'>*</span></p>
                        <textarea value={surveyData.servicesComments} onChange={(e) => {
                            setErrors({...errors, servicesComments:''})
                            setSurveyData({...surveyData, servicesComments:e.target.value}) 
                        }} 
                        rows={4} className='p-2 border border-black  w-full xl:w-[800px]' />
                        {errors.servicesComments && (
                            <span className='text-[14px] text-red-500 font-bold'>{errors.servicesComments}</span>
                        )}
                    </div>
                    <div className='flex flex-col gap-[10px]'>
                        <p className='text-xl font-black'>Sanger Confirmation</p>
                        <p className='text-lg'>As a follow-up service, I would be interested in validating my plasmid sequences with discounted Sanger sequencing.</p>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="sanger-radio" value={"Strongly Disagree"} onChange={(e) => setSurveyData({...surveyData, sangerRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Strongly Disagree</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="sanger-radio" value={"Slightly Disagree"} onChange={(e) => setSurveyData({...surveyData, sangerRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Slightly Disagree</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="sanger-radio" value={"Neutral"} onChange={(e) => setSurveyData({...surveyData, sangerRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Neutral</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="sanger-radio" value={"Slightly Agree"} onChange={(e) => setSurveyData({...surveyData, sangerRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Slightly Agree</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="sanger-radio" value={"Strongly Agree"} onChange={(e) => setSurveyData({...surveyData, sangerRating:e.target.value})} className='w-[20px] h-[20px]' />
                            <p className='text-lg'>Strongly Agree</p>
                        </div>
                        <p className='mt-2 text-lg'>Comments:<span className='text-red-600 text-2xl'>*</span></p>
                        <textarea value={surveyData.sangerComments} onChange={(e) => {
                            setErrors({...errors, sangerComments:''})
                            setSurveyData({...surveyData, sangerComments:e.target.value})
                        }} 
                        rows={4} className='p-2 border border-black  w-full xl:w-[800px]' />
                        {errors.sangerComments && (
                            <span className='text-[14px] text-red-500 font-bold'>{errors.sangerComments}</span>
                        )}
                    </div>
                    <div className='flex flex-col gap-[10px]'>
                        <p className='text-xl font-black'>Miscellaneous</p>
                        <p className='text-lg'>What would you suggest to help us improve our WPS service?</p>
                        <p className='mt-2 text-lg'>Comments:<span className='text-red-600 text-2xl'>*</span></p>
                        <textarea value={surveyData.miscComments} onChange={(e) => {
                            setErrors({...errors, miscComments:''})
                            setSurveyData({...surveyData, miscComments:e.target.value}) 
                        }} 
                        rows={4} className='p-2 border border-black  w-full xl:w-[800px]' />
                        {errors.miscComments && (
                            <span className='text-[14px] text-red-500 font-bold'>{errors.miscComments}</span>
                        )}
                    </div>
                    <div className='flex flex-col gap-[10px]'>
                        <p className='text-xl'>ACGT may post my comment(s) on their website. The post will not use my last name but only my first name and last initial, title and company/institution.</p>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="contact-radio" 
                            value={"Yes"}
                            checked={surveyData.contactTheCustomer === 'Yes'} 
                            onChange={(e) => setSurveyData({...surveyData, contactTheCustomer:e.target.value})} 
                            className='min-w-[20px] w-[20px] h-[20px]' />
                            <p className='text-lg'>Yes</p>
                        </div>
                        <div className='flex items-center gap-[10px]'>
                            <input type="radio" name="contact-radio" 
                            value={"No"} 
                            checked={surveyData.contactTheCustomer === 'No'} 
                            onChange={(e) => setSurveyData({...surveyData, contactTheCustomer:e.target.value})} 
                            className='min-w-[20px] w-[20px] h-[20px]' />
                            <p className='text-lg'>No</p>
                        </div>
                    </div>
                    <div className='flex gap-[30px] justify-center sm:justify-start'>
                        <button
                        className={`border-2 border-[#302a7e] px-4 py-2 rounded-3xl font-bold gap-2 ${buttonColor? 'bg-[#58595b] pointer-events-none' : 'bg-[#302a7e] '} text-white uppercase min-w-[159px] h-[43px] mb-16`}
                        onClick={() => handleSurvey()}
                        >
                        Submit
                        </button>
                        <button
                        className='border-2 border-[#302a7e] px-4 py-2 rounded-3xl font-bold gap-2 text-[var(--color-primary-purple)] bg-white uppercase min-w-[159px] h-[43px] mb-16'
                        onClick={() => navigate('/dashboard')}
                        >
                        Cancel
                        </button>
                    </div>
                </div>
            </div>
        }   
      
      </div> 
      :
        <div className=' px-[16px] sm:px-[40px] xl:px-[128px]'>
            <div className="flex flex-col sm:flex-row justify-between items-center my-[40px] gap-[20px]">
            <h1 className='text-center sm:!text-left text-4xl text-[var(--color-primary-purple)] font-black '>
            Survey: Whole Plasmid Sequencing
            </h1>
            </div>
            <div className="flex flex-col items-center gap-[10px] mt-10">
                <div className="flex items-center justify-center gap-[8px]">
                        <p className="text-center font-bold text-2xl text-[var(--color-primary-purple)]">Thank you for completing our survey previously.</p>
                </div>
                <button
                className='mt-12 border-2 border-[#302a7e] px-4 py-2 rounded-3xl font-bold gap-2 text-[var(--color-primary-purple)] bg-white uppercase min-w-[289px] h-[43px] mb-16'
                onClick={() => navigate('/dashboard')}
                >
                    go back to account home
                </button>
            </div>
        </div>
    }
       
    </>
    
  )
}

export default SurveyWps